import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section id="contact" className="py-24 bg-[#C1694F] relative overflow-hidden" data-id="element-29">
      {/* Abstract Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-30">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-31">
          <defs data-id="element-32">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-33">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" data-id="element-34" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-35" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-37">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-38">
            Experience How This Property Lives
          </h2>
          <p className="text-xl text-white/90 mb-10 font-light" data-id="element-39">
            Photos can't capture the silence, the views, or the scale of the
            workshop. Come see why this is the rarest find in Desert Hills.
          </p>

          <div className="bg-white p-12 rounded-xl shadow-2xl max-w-lg mx-auto" data-id="element-40">
            <div className="w-16 h-16 bg-[#C1694F]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-41">
              <Calendar className="w-8 h-8 text-[#C1694F]" data-id="element-42" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-[#2D2D2D] mb-4" data-id="element-43">
              Schedule a Private Tour
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-44">
              Choose a time that works for you and we'll show you everything
              this property has to offer.
            </p>
            <a href="https://calendar.app.google/wrWsFckucxpttSGB6" target="_blank" rel="noopener noreferrer" className="block" data-id="element-45">
              <Button variant="primary" size="lg" className="w-full" data-id="element-46">
                Book Your Tour
              </Button>
            </a>
            <p className="text-xs text-gray-500 mt-6" data-id="element-47">
              Strictly confidential. No obligation.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}